var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.readonly)?_c('script',{ref:"_UEditor",staticClass:"my-ueditor",staticStyle:{"height":"300px"},attrs:{"id":"","name":"_UEditor","type":"text/plain"}}):_vm._e(),_vm._v(" "),(_vm.readonly)?_c('div',{staticClass:"ueditor-readonly",domProps:{"innerHTML":_vm._s(_vm.value)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }